/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  closeModal, userData, switchModal, signupUser, clearUserStatuses,
} from '../../actions';
import Girl from '../../assets/login/girl.svg';
import X from '../../assets/login/x.svg';

class Register3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      futureWork: '',
      workField: '',
      workFieldError: false,
      futureWorkError: false,
    };
  }

  componentDidMount() {
    this.props.clearUserStatuses();
  }

  componentDidUpdate(prevProps) {
    if (this.props.user_info.authenticated) {
      this.props.switchModal('OnboardingInitial');
    }
  }

  componentWillUnmount() {
    this.props.clearUserStatuses();
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }

  signUp = () => {
    this.setState((prevState) => {
      return {
        workFieldError: prevState.workField === '',
        futureWorkError: prevState.futureWork === '',
      };
    }, () => {
      if (
        !this.state.workFieldError
        && !this.state.futureWorkError
      ) {
        const object = {
          workField: this.state.workField,
          futureWork: this.state.futureWork,
        };
        this.props.userData(object);
        const data = this.props.user_info;
        const newObject = {
          email: data.email,
          password: data.password,
          first_name: data.firstName,
          last_name: data.lastName,
          occupation: data.occupation,
          age: data.age,
          work_field: this.state.workField,
          future_work: this.state.futureWork,
        };
        this.props.signupUser(newObject);
      }
    });
  }

  render() {
    return (
      <div className="modal">
        <img className="x-icon" onClick={this.props.closeModal} src={X} alt="x" />
        <div className="sign-in-container">
          <img src={Girl} alt="person" />
          <div className="sign-in-body">
            <div className="sign-in-header">
              Last questions...
            </div>
            <div className="sign-in-text">
              These will assist in our research to improve the product over time.
            </div>
            <div className="form-container">
              <div className="sign-in-form-row">
                <label htmlFor="e-name" className="label-style">
                  What field of work are you currently in?
                </label>
                {this.state.workFieldError ? (
                  <p className="modal-form-error">This field cannot be left blank</p>
                ) : null}
                <textarea
                  type="text"
                  name="workField"
                  className="sign-in-form-input tall-input"
                  value={this.state.workField}
                  onChange={this.handleChange}
                />
              </div>
              <div className="sign-in-form-row">
                <label htmlFor="e-pass" className="label-style">
                  What domain of work do you <i>want</i> to be in?
                </label>
                {this.state.futureWorkError ? <p className="modal-form-error">This field cannot be left blank</p> : null}
                <textarea
                  type="text"
                  name="futureWork"
                  className="sign-in-form-input tall-input"
                  value={this.state.futureWork}
                  onChange={this.handleChange}
                />
              </div>
              <div className="sign-in-bubble">
                <input type="button" value="Create Account" className="sign-in-button" onClick={() => { this.signUp(); }} />
                {this.props.authError
                  ? (
                    <p className="signin-error">There was an error registering your account.
                      This could happen if your email is associated with an existing account. Please exit this screen and try again.
                    </p>
                  )
                  : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => (
  {
    toggle: state.modal.clicked,
    user_info: state.user,
    authError: state.user.authError,
  }
);

export default connect(mapStateToProps, {
  closeModal, userData, switchModal, signupUser, clearUserStatuses,
})(Register3);
